import produce from 'immer'
import * as C from './constants'

const analyticsReducer = (state = C.INITIAL_STATE, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case C.OUTGOING_CALL_SOURCE_SET:
        draft.outgoingCallSource = action.payload
        break
      case C.OUTGOING_CALL_SOURCE_CLEAR:
        draft.outgoingCallSource = C.OUTGOING.UNKNOWN
        break
      default:
        break
    }
  })
}

export default analyticsReducer
